import React from 'react';
import { Box, Flex, Text, useBreakpoint, useColorModeValue } from '@chakra-ui/react';
import { ThemeToggle } from '../ThemeToggle/ThemeToggle';
import { WalletConnectButton } from '../WalletConnectButton/WalletConnectButton';
import { formatUSD } from '../../utils/format';
import { useWallet } from '../../contexts/WalletContext';
import { Typography } from '@/kit/antipad-ui/Typography';

export const Header: React.FC = () => {
  const textColor = useColorModeValue('gray.800', 'white');
  const bgColor = useColorModeValue('white', 'gray.800');
  const { publicKey, balance } = useWallet();

  const screen = useBreakpoint();
  const isMobile = screen === 'base';

  const text = isMobile ? formatUSD(balance) : `Your Wallet Balance: ${formatUSD(balance)}`;
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      bg="#101010"
      py={4}
      px={4}
    >
      <Flex justify="flex-end" align="center" gap={4}>
        {publicKey && (
          <Box
            px={4}
            py={4}
            bg="var(--color-background-neutral-subtle)"
            borderRadius="3xl"
            boxShadow="sm"

          >
            <Typography variant={isMobile ? 'small' : 'regular'} color={textColor}>
              {text}
            </Typography>
          </Box>
        )}
        <WalletConnectButton />
        {/* <ThemeToggle /> */}
      </Flex>
    </Box>
  );
}; 